import * as React from 'react';
import {LinearLoader} from '@spaced-out/ui-design-system/lib/components/LinearLoader';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {classify} from 'src/utils/classify';
import Logo from 'src/images/sense-logo.svg';

import css from './fullscreen-loader.css';


export const FullscreenLoader = ({
  description,
  loaderType = 'linear',
  showLogo = true,
  headerSlot,
}: {
  description?: React.ReactNode;
  loaderType?: 'linear' | 'circular';
  showLogo?: boolean;
  headerSlot?: React.ReactNode;
}) => {
  const loader = (
    <>
      {showLogo && <Logo className={css.logo} />}
      {loaderType === 'linear' ? (
        <LinearLoader
          className={css.loader}
          value={100}
          size="medium"
          indeterminate
        />
      ) : (
        <CircularLoader
          className={css.circularLoader}
          colorToken="colorFillPrimary"
          size="large"
        />
      )}
      {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
      <div className={css.description}>{description}</div>
    </>
  );

  if (headerSlot) {
    return (
      <div className={css.headerSlotContainer}>
        {}
        {headerSlot}
        <div className={css.loadingContainerWithHeaderSlot}>
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          {loader}
        </div>
      </div>
    );
  }

  return <div className={css.loadingContainer}>{loader}</div>;
};
